// qtyLeft.ts — pure display helper for wizard step 2: how many units/days a
// rated charge can still invoice against a PO line's remaining dollars, at
// the charge's agreed rate. Display-only — deliberately NOT part of the
// mirrored FE<->BE financeCalc layer (no derivation output depends on it).
// Returns null when there is no usable rate, so unrated (manual / milestone /
// SOW) charges render exactly as before.

export function formatQtyLeft(
  remainingDollars: number,
  rate: number | null | undefined,
  unit?: string,
): string | null {
  if (rate === null || rate === undefined || !Number.isFinite(rate) || rate <= 0) return null;
  if (!Number.isFinite(remainingDollars)) return null;
  const qty = Math.max(0, remainingDollars) / rate;
  const rounded = Math.round(qty * 10) / 10;
  const display = Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(1);
  const label = unit && unit.trim() ? unit.trim() : "unit";
  const plural = rounded === 1 ? label : `${label}s`;
  return `≈ ${display} ${plural}`;
}
